import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ItemRowWithOptions from "../../../../Components/Table/ItemRowWithOptions";
import ItemColumn from "../../../../Components/Table/ItemColumn";
import CommonStepList from "../../CommonStepList";
import FormOwner from "./FormOwner";
import { CustomModal } from "../../../../Components/Modal";
import { Typography } from "@mui/material";

export default function ListOwners({ owners, onOwnerUpdated, onOwnerDeleted }) {
  const [t, i18n] = useTranslation("global");
  const [currentOwner, setCurrentOwner] = useState(null);
  const [searchOwner, setSearchOwner] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [configModal, setConfigModal] = useState({
    title: "",
    type: "edit",
  });

  const onItemOwnerEdit = (owner) => {
    setCurrentOwner(owner);
    setOpenModal(!openModal);
    setConfigModal({
      title: t("initial_setup.modals.edit_owner"),
      type: "edit",
      cancelText: t("components_globals.button_cancel"),
      acceptText: t("components_globals.button_update"),
    });
  };
  const onItemOwnerDelete = (owner) => {
    setCurrentOwner(owner);
    setOpenModal(!openModal);
    setConfigModal({
      title:
       <div
       style={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
      }}
       >
         {`${t("initial_setup.modals.delete_owner")} `}
         <br />
          <Typography variant="body" fontWeight={600}>{owner.name}</Typography>
         </div>,
      type: "delete",
      cancelText: t("components_globals.button_cancel"),
      acceptText: t("components_globals.button_ok"),
    });
  };

  const onChangeSearchOwner = (filter) => {
    if (filter) {
      setSearchOwner(filter);
    } else {
      setSearchOwner("");
    }
  };

  const handleCloseModal = () => {
    setOpenModal(!openModal);
    setCurrentOwner(null);
  };

  const handleCancelModal = () => {
    setOpenModal(!openModal);
    setCurrentOwner(null);
  };

  const handleOkModal = () => {
    switch (configModal.type) {
      case "edit":
        onOwnerUpdated(currentOwner);
        break;

      case "delete":
        onOwnerDeleted(currentOwner);
        break;
    }
    setOpenModal(!openModal);
  };

  const filterOwners = (filter) => {
    if (filter) {
      return owners.filter(
        (owner) =>
          owner.name.toUpperCase().indexOf(filter.toUpperCase()) != -1 ||
          owner.description.toUpperCase().indexOf(filter.toUpperCase()) != -1
      );
    } else {
      return owners;
    }
  };

  const ownersFiltered = filterOwners(searchOwner);

  const columnNames = [
    t("initial_setup.forms.common_inputs.name"),
    t("initial_setup.forms.common_inputs.description"),
    t("initial_setup.forms.common_inputs.color"),
    t("initial_setup.forms.common_inputs.options"),
  ];
  const listOwnerItems = ownersFiltered.map((owner, index) => {
    return (
      <ItemRowWithOptions
        key={index}
        index={index}
        withCommonButtons={true}
        onItemEdit={() => onItemOwnerEdit(owner)}
        tooltipTitleEdit={t("components_globals.button_edit")}
        onItemDelete={() => onItemOwnerDelete(owner)}
        tooltipTitleDelete={t("components_globals.button_remove")}
      >
        <ItemColumn>{owner.name}</ItemColumn>
        <ItemColumn>{owner.description}</ItemColumn>
        <ItemColumn>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              className="color"
              style={{ backgroundColor: owner.color }}
            ></div>
          </div>
        </ItemColumn>
      </ItemRowWithOptions>
    );
  });
  return (
    <>
      <CommonStepList
        listItems={listOwnerItems}
        onChangeSearchItem={onChangeSearchOwner}
        filterFn={filterOwners}
        columnNames={columnNames}
        paginationTitle={t("initial_setup.step_2.stage_1.title")}
      ></CommonStepList>
      <CustomModal
      customWidth='600px'
        title={configModal.title}
        type={configModal.type}
        open={openModal}
        onCloseModal={handleCloseModal}
        onCancelModal={handleCancelModal}
        onOkModal={handleOkModal}
        cancelText={configModal.cancelText}
        acceptText={configModal.acceptText}
      >
        {configModal.type === "edit" && (
          <FormOwner
            owner={currentOwner}
            setCurrentOwner={setCurrentOwner}
          ></FormOwner>
        )}
      </CustomModal>
    </>
  );
}
